import Banner from "../components/Gallery/Banner/Banner";
import Photos from "../components/Gallery/Photos/Photos";
import HelmetLayout from "../components/GlobalComponents/HelmetLayout";

const Gallery = () => {
    return (
        <HelmetLayout
            name="Gallery"
            title="Ard Altaamir Gallery: Moments, Craftsmanship & Brand Story in Images"
            description="Explore the Ard Altaamir Gallery – a curated collection of images showcasing our craftsmanship, behind-the-scenes moments, milestones, and the values that shape our brand. Discover the story behind every product."
            route="gallery"
        >
            <Banner />
            <Photos />

        </HelmetLayout>
    );
};

export default Gallery;
